import { getDictionary } from '@/shared/lib/i18n';
import { ActivityLogAction, ActivityLogSendMethod } from '../../model';

export const getActivityLabel = ({
  action,
  source,
}: {
  action: ActivityLogAction;
  source: ActivityLogSendMethod | undefined;
}): string => {
  const dictionary = getDictionary();

  const sourceMap: Record<ActivityLogSendMethod, Partial<Record<ActivityLogAction, string>> | string> = {
    [ActivityLogSendMethod.Call]: dictionary.called,
    [ActivityLogSendMethod.Werknl]: dictionary.Werknl,
    [ActivityLogSendMethod.Whatsapp]: dictionary.whatsappSent,
    [ActivityLogSendMethod.Email]: {
      [ActivityLogAction.EmailSent]: dictionary.emailSent,
      [ActivityLogAction.Contacted]: dictionary.emailSent,
      [ActivityLogAction.EmailReceived]: dictionary.emailReceived,
      [ActivityLogAction.MessageReceived]: dictionary.emailReceived,
    },
    [ActivityLogSendMethod.InMail]: {
      [ActivityLogAction.InMailSent]: dictionary.linkedinInmailSent,
      [ActivityLogAction.Contacted]: dictionary.linkedinInmailSent,
      [ActivityLogAction.InMailReceived]: dictionary.linkedIn,
      [ActivityLogAction.MessageReceived]: dictionary.linkedIn,
    },
    [ActivityLogSendMethod.Indeed]: {
      [ActivityLogAction.IndeedSent]: dictionary.indeedSent,
      [ActivityLogAction.Contacted]: dictionary.indeedSent,
      [ActivityLogAction.IndeedReceived]: dictionary.indeedReceived,
      [ActivityLogAction.MessageReceived]: dictionary.indeedReceived,
    },
    [ActivityLogSendMethod.Linkedin]: {
      [ActivityLogAction.LinkedinSent]: dictionary.linkedinConnectionSent,
      [ActivityLogAction.Contacted]: dictionary.linkedinConnectionSent,
      [ActivityLogAction.LinkedinReceived]: dictionary.linkedIn,
      [ActivityLogAction.MessageReceived]: dictionary.linkedIn,
    },
  };

  const actionMapping: Record<ActivityLogAction, string> = {
    [ActivityLogAction.Contacted]: dictionary.contacted,
    [ActivityLogAction.Hidden]: dictionary.hidden,
    [ActivityLogAction.Invisible]: dictionary.hidden,
    [ActivityLogAction.LabelChanged]: dictionary.labelsChanged,
    [ActivityLogAction.Matched]: dictionary.matched,
    [ActivityLogAction.Note]: dictionary.noteAdded,
    [ActivityLogAction.SentToAts]: dictionary.sentToAts,
    [ActivityLogAction.Shortlisted]: dictionary.shortlisted,
    [ActivityLogAction.Unlocked]: dictionary.unlocked,
    [ActivityLogAction.AtsCandidateContact]: dictionary.atsEmailSent,
    [ActivityLogAction.AtsStatusChanged]: dictionary.atsCandidateStatusChanged,
    [ActivityLogAction.AtsNoteCreated]: dictionary.atsNoteAdded,

    [ActivityLogAction.EmailSent]: dictionary.emailSent,
    [ActivityLogAction.EmailReceived]: dictionary.emailReceived,
    [ActivityLogAction.FollowUpPlanned]: dictionary.emailFollowUpPlanned,
    [ActivityLogAction.FollowUpSent]: dictionary.emailSent,
    [ActivityLogAction.MessageReceived]: dictionary.emailReceived,

    [ActivityLogAction.LinkedinSent]: dictionary.linkedinConnectionSent,
    [ActivityLogAction.LinkedinReceived]: dictionary.linkedIn,
    [ActivityLogAction.InMailSent]: dictionary.linkedinInmailSent,
    [ActivityLogAction.InMailReceived]: dictionary.linkedIn,

    [ActivityLogAction.IndeedSent]: dictionary.indeedSent,
    [ActivityLogAction.IndeedReceived]: dictionary.indeedReceived,

    [ActivityLogAction.RJCommHubPipelineExpired]: dictionary.communicationEnded,
    [ActivityLogAction.RJCommHubInitialMessageSent]: dictionary.emailSent,
    [ActivityLogAction.RJCommHubFollowUpPlanned]: dictionary.emailFollowUpPlanned,
    [ActivityLogAction.RJCommHubFollowUpSent]: dictionary.emailSent,
    [ActivityLogAction.RJCommHubCandidateAccepted]: dictionary.emailReceived,
    [ActivityLogAction.RJCommHubCandidateRejected]: dictionary.emailReceived,
    [ActivityLogAction.CandidateAppliedRecommendation]: dictionary.emailReceived,

    [ActivityLogAction.CalendarInterviewInvitationSent]: dictionary.calendarInterviewInvitationSent,
    [ActivityLogAction.CalendarInterviewInvitationAccepted]: dictionary.calendarInterviewInvitationAccepted,
    [ActivityLogAction.CalendarInterviewInvitationRescheduled]: dictionary.calendarInterviewInvitationRescheduled,
    [ActivityLogAction.CalendarInterviewInvitationRejected]: dictionary.calendarInterviewInvitationRejected,
  };

  return (
    (source && (typeof sourceMap[source] === 'string' ? sourceMap[source] : sourceMap[source][action])) ||
    actionMapping[action] ||
    ''
  );
};
